import { render, staticRenderFns } from "./Custody.vue?vue&type=template&id=b1a731ec&scoped=true&"
import script from "./Custody.vue?vue&type=script&lang=js&"
export * from "./Custody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a731ec",
  null
  
)

export default component.exports